import React from 'react';
import { Card, Skeleton, Grid, Space, Row, Col, Flex, theme } from 'antd';
import { BookOutlined } from '@ant-design/icons';
import { useTheme } from '../Shared/GlobalContext/ThemeContext';

const { useBreakpoint } = Grid;

const KnowledgeBaseSkeletonItem = () => {
    const screens = useBreakpoint();
    const isMobile = screens?.xs;
    const { token } = theme.useToken(); // Get theme tokens
    const { isDarkMode } = useTheme();
    
    return (
        <Card
            style={{
                width: isMobile ? '100%' : '260px',
                height: 'fit-content',
                backgroundColor: token.colorBgContainer,
                border: isDarkMode ? `1px solid ${token.colorBorder}` : 'none',
            }}
            bordered={false}
            styles={{
                body: {
                    padding: isMobile ? '12px' : '20px',
                    display: 'flex',
                    flexDirection: 'column',
                    paddingBottom: 5,
                    height: '252px',
                }
            }}
            actions={[
                <Skeleton.Button active size="small" shape="circle" key="1" />,
                <Skeleton.Button active size="small" shape="circle" key="2" />,
                <Skeleton.Button active size="small" shape="circle" key="3" />
            ]}
        >
            <Space direction="vertical" size="middle" style={{
                width: '100%',
                height: '100%',
                display: 'flex'
            }}>
                <Row gutter={8} align="top" wrap={isMobile}>
                    <Col flex="none">
                        <BookOutlined
                            style={{
                                fontSize: '32px',
                                color: token.colorPrimary,
                                opacity: 0.6
                            }}
                        />
                    </Col>
                    <Col flex="auto">
                        <Space direction="vertical" size={4} style={{ width: '100%' }}>
                            {/* Knowledge base name */}
                            <Skeleton.Input
                                active
                                style={{
                                    width: '100%',
                                    height: '24px',
                                    marginBottom: '4px'
                                }}
                            />
                            
                            {/* Description */}
                            <Skeleton.Input
                                active
                                style={{
                                    width: '80%',
                                    height: '22px',
                                    marginBottom: '8px'
                                }}
                            />
                            
                            {/* Tags */}
                            <Flex gap={4}>
                                <Skeleton.Button
                                    active
                                    size="small"
                                    style={{
                                        width: '60px',
                                        height: '22px',
                                        borderRadius: '10px'
                                    }}
                                />
                                <Skeleton.Button
                                    active
                                    size="small"
                                    style={{
                                        width: '60px',
                                        height: '22px',
                                        borderRadius: '10px'
                                    }}
                                />
                            </Flex>
                        </Space>
                    </Col>
                </Row>

                <Space
                    direction="vertical"
                    size={8}
                    style={{
                        width: '100%',
                        flex: 1,
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'flex-start'
                    }}
                >
                    {/* First entry */}
                    <Flex gap={8}>
                        <Skeleton.Avatar
                            active
                            size="small"
                            style={{
                                marginTop: '4px',
                            }}
                        />
                        <div style={{ width: '100%' }}>
                            <Skeleton.Input
                                active
                                style={{
                                    width: '100%',
                                    height: '20px',
                                    marginBottom: '4px'
                                }}
                            />
                            <Skeleton.Input
                                active
                                style={{
                                    width: '80%',
                                    height: '16px',
                                    marginLeft: '28px',
                                }}
                            />
                        </div>
                    </Flex>

                    {/* Second entry */}
                    <Flex gap={8}>
                        <Skeleton.Avatar
                            active
                            size="small"
                            style={{
                                marginTop: '4px',
                            }}
                        />
                        <Skeleton.Input
                            active
                            style={{
                                width: '100%',
                                height: '20px',
                            }}
                        />
                    </Flex>

                    {/* More entries indication */}
                    <Skeleton.Input
                        active
                        style={{
                            width: '40%',
                            height: '16px',
                        }}
                    />
                </Space>
            </Space>
        </Card>
    );
};

export default KnowledgeBaseSkeletonItem; 